export default [
	{
		path: '/app/auth',
		component: () => import('../../../layouts/UnauthLayout'), // 使用するレイアウトの選択
		children: [
			{
				path: 'login', // 親と同じpathで表示するコンポーネントを下記で指定
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/auth/LoginView'),
				meta: { title:'YubiOn SecureFileTransfer | Login'}
			},
			{
				path: 'activateUser', // 親と同じpathで表示するコンポーネントを下記で指定
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/auth/ActivateUserView'),
				meta: { title:'YubiOn SecureFileTransfer | Login'}
			},
			{
				path: 'requestResetPassword', // 親と同じpathで表示するコンポーネントを下記で指定
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/auth/RequestResetPasswordView'),
				meta: { title:'YubiOn SecureFileTransfer | Request Reset Password'}
			},
			{
				path: 'resetPassword', // 親と同じpathで表示するコンポーネントを下記で指定
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/auth/ResetPasswordView'),
				meta: { title:'YubiOn SecureFileTransfer | Reset Password'}
			},
		]
	},
	{
		path: '/app/auth',
		component: () => import('../../../layouts/AuthModalLayout'), // 使用するレイアウトの選択
		children: [
			{
				path: 'loginModal', // 親と同じpathで表示するコンポーネントを下記で指定
				component: () => import(/* webpackChunkName: "dashboard" */ '../../../components/auth/LoginView'),
				meta: { title:'YubiOn SecureFileTransfer | Login'}
			},
		]
	}
]
